import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

// Components
import IconButton from "../Atoms/IconButton";

// Stylesheets
import "./QuantityPicker.scss";

const QuantityPicker = ({
  className,
  handleIncrement,
  handleDecrement,
  quantity,
  productName,
}) => {
  const classname = classNames("quantity_picker", className);

  return (
    <div className={classname}>
      <div className="quantity_picker_container">
        <IconButton
          ariaLabel={`Decrease Quantity of ${productName}`}
          onClick={handleDecrement}
          className="quantity_update_button body_secondary"
        >
          -
        </IconButton>
        <span className="body_secondary quantity">{quantity}</span>
        <IconButton
          ariaLabel={`Increase Quantity of ${productName}`}
          onClick={handleIncrement}
          className="quantity_update_button body_secondary"
        >
          +
        </IconButton>
      </div>
    </div>
  );
};

QuantityPicker.propTypes = {
  className: PropTypes.any,
  handleIncrement: PropTypes.func.isRequired,
  handleDecrement: PropTypes.func.isRequired,
  quantity: PropTypes.number,
  productName: PropTypes.string.isRequired,
};

export default QuantityPicker;
